import scriptComponentResolver from './utils/scriptComponentResolver';

const scripts = ['facebookPixelMarketing', 'taboolaPixel', 'outbrianPixel'];

export default function PpScripts() {
  const scriptsJSX = scripts.map(scriptComponentResolver);

  return <>{scriptsJSX}</>;
}
